import { apiRequest } from '../axiosInstance';
import axiosInstance from '../axiosInstance';
import { ORGANIZATION_LICENSE_ENDPOINTS, buildQueryString } from '../endpoints';

const organizationLicenseService = {
  getAllLicenses: async (params = {}) => {
    const queryString = buildQueryString(params);
    return apiRequest(() =>
      axiosInstance.get(`${ORGANIZATION_LICENSE_ENDPOINTS.LIST}${queryString}`)
    );
  },

  getLicenseForOrg: async (orgId) => {
    return apiRequest(() =>
      axiosInstance.get(ORGANIZATION_LICENSE_ENDPOINTS.GET_FOR_ORG(orgId))
    );
  },

  getMyLicense: async () => {
    return apiRequest(() =>
      axiosInstance.get(ORGANIZATION_LICENSE_ENDPOINTS.MY_LICENSE)
    );
  },

  assignLicense: async (licenseData) => {
    return apiRequest(() =>
      axiosInstance.post(ORGANIZATION_LICENSE_ENDPOINTS.ASSIGN, licenseData)
    );
  },

  updateLicense: async (id, licenseData) => {
    return apiRequest(() =>
      axiosInstance.put(ORGANIZATION_LICENSE_ENDPOINTS.UPDATE(id), licenseData)
    );
  },

  suspendLicense: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(ORGANIZATION_LICENSE_ENDPOINTS.SUSPEND(id))
    );
  },

  reactivateLicense: async (id) => {
    return apiRequest(() =>
      axiosInstance.post(ORGANIZATION_LICENSE_ENDPOINTS.REACTIVATE(id))
    );
  },

  extendLicense: async (id, newExpiryDate) => {
    return apiRequest(() =>
      axiosInstance.post(ORGANIZATION_LICENSE_ENDPOINTS.EXTEND(id), { newExpiryDate })
    );
  },
};

export default organizationLicenseService;
